<app-header></app-header>

<!-- Middle Content CSS End Here  -->
<div class="middle-content-wrap">
    <!-- Dashboard HTML Start Here  -->
    <div class="globalheading d-flex justify-content-between align-items-center">
        <h2 class="mb-0">
            Group Dates
        </h2>
        <div class="common_btn" *ngIf="!isManager">
            <button type="button" class="add-user-btn" data-toggle="modal" data-target="#groupDateModal"
                (click)="onAddGroupDateClick()">
                Add Group Date
            </button>
        </div>
    </div>
    <div class="row pt-3">
        <div class="col-12 col-md-4 mb-2 mb-md-0 px-2 px-md-0" (click)="selectTab('upcoming')">
            <button type="button" class="add-user-btn tab_btn w-100"
                [ngClass]="{'black_btn': activeTab === 'upcoming'}">Upcoming</button>
        </div>
        <div class="col-12 col-md-4 mb-2 mb-md-0 px-2 px-md-0" (click)="selectTab('open')">
            <button type="button" class="add-user-btn tab_btn w-100"
                [ngClass]="{'black_btn': activeTab === 'open'}">Open/Closed</button>
        </div>
        <div class="col-12 col-md-4 mb-2 mb-md-0 px-2 px-md-0" (click)="selectTab('completed')">
            <button type="button" class="add-user-btn tab_btn w-100"
                [ngClass]="{'black_btn': activeTab === 'completed'}">Completed</button>
        </div>
    </div>
    <div class="listingformat">
        <div class="tabledatawrap table-responsive">
            <table>
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>title</th>
                        <th>Booking Time</th>
                        <th>Slot Opens At</th>
                        <th>Location</th>
                        <th>Capacity</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        *ngFor="let date of filteredDates | paginate:{id: 'groupDates', itemsPerPage: total, currentPage: p, totalItems: count}">
                        <td>{{ date.id }}</td>
                        <td>{{ date.title }}</td>
                        <td>{{ date.slot_date | date }} {{ date.slot_time }}</td>
                        <td>{{ date.slot_opens_at | date }} (Closes After: {{ date.slot_closes_after }} hours)</td>
                        <td>{{ date.venue_name }} , {{date.address}}</td>
                        <td>{{ date.max_participants }}</td>
                        <td>
                            <span class="badge" [ngClass]="{
                                'bg-success': date.status === 'Active',
                                'bg-warning': date.status === 'Pending',
                                'bg-danger': date.status === 'Cancelled',
                                'bg-info': date.status === 'Completed'
                            }">
                                {{ date.status }}
                            </span>
                        </td>
                        <td>
                            <div class="action-btns hide-profile-btn">
                                <button [routerLink]="['/group-dates', date.id, 'attendees']" class="mr-2">
                                    <i class="fa fa-eye" aria-hidden="true"></i>
                                </button>
                                <button (click)="onEditGroupDateClick(date)" class="mr-2"
                                    *ngIf="activeTab !== 'completed' && !isManager">
                                    <i class="fa fa-edit" aria-hidden="true"></i>
                                </button>
                                <button (click)="openDeleteModal(date)" *ngIf="!isManager">
                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tbody *ngIf="filteredDates?.length==0">
                    <tr>
                        <td colspan="8">No Data Found</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="row">
            <div class="col-md-12 custompagination">
                <pagination-controls class="" previousLabel="Prev" nextLabel="Next" id="groupDates"
                    (pageChange)="onTableDataChange($event)">
                </pagination-controls>
            </div>
        </div>
    </div>
    <!-- Dashboard HTML End Here  -->
</div>
<!-- Middle Content CSS End Here  -->


<!-- Delete Popup -->
<div class="modal fade bd-example-modal-sm common_modal" id="deleteDateModal" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog animated fadeInDown">
        <div class="modal-content">
            <div class="modal-header">
                <div class="popupheding">
                    Delete Group Date
                </div>
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
            <div class="modal-body">
                <div class="filtercard">
                    <p>Are you sure you want to delete this group date?</p>
                    <div class="common_btn">
                        <button data-dismiss="modal">Cancel</button>
                        <button (click)="deleteDate()" class="btn-danger">Delete</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Group Date Modal (Add/Edit) -->
<div class="modal fade bd-example-modal-lg common_modal" id="groupDateModal" tabindex="-1" role="dialog"
    aria-labelledby="groupDateModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg animated fadeInDown">
        <div class="modal-content">
            <div class="modal-header">
                <div class="popupheding">
                    {{ selectedDateId ? 'Edit' : 'Add New' }} Group Date
                </div>
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
            <div class="modal-body">
                <div class="filtercard">
                    <form [formGroup]="groupDateForm" (ngSubmit)="onSubmit()">
                        <div class="scrollable-form">
                            <div class="row">
                                <!-- Basic Information -->
                                <div class="col-md-12">
                                    <div>
                                        <label>Title*</label>
                                        <input type="text" class="form-control" formControlName="title"
                                            placeholder="Enter title" style="display: block;" required>
                                        <div *ngIf="submitted && f['title'].errors" class="invalid-feedback d-block">
                                            <div *ngIf="f['title'].errors['required']">Title is required</div>
                                        </div>
                                    </div>
                                    <div>
                                        <label>Description*</label>
                                        <textarea class="form-control" formControlName="description" rows="3"
                                            placeholder="Enter description" required></textarea>
                                        <div *ngIf="submitted && f['description'].errors"
                                            class="invalid-feedback d-block">
                                            <div *ngIf="f['description'].errors['required']">Description is required
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <label>Maximum Participants*</label>
                                            <input type="number" class="form-control" formControlName="max_participants"
                                                min="2" max="100" required>
                                            <div *ngIf="submitted && f['max_participants'].errors"
                                                class="invalid-feedback d-block">
                                                <div *ngIf="f['max_participants'].errors['required']">Maximum
                                                    participants
                                                    is required</div>
                                                <div *ngIf="f['max_participants'].errors['min']">Must be at least 2
                                                </div>
                                                <div *ngIf="f['max_participants'].errors['max']">Cannot exceed 100</div>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <label>Maximum Participants Limit*</label>
                                            <input type="number" class="form-control"
                                                formControlName="max_participants_limit" min="2" max="100" required>
                                            <div *ngIf="submitted && f['max_participants_limit'].errors"
                                                class="invalid-feedback d-block">
                                                <div *ngIf="f['max_participants_limit'].errors['required']">Maximum
                                                    participants limit
                                                    is required</div>
                                                <div *ngIf="f['max_participants_limit'].errors['min']">Must be at least
                                                    2</div>
                                                <div *ngIf="f['max_participants_limit'].errors['max']">Cannot exceed 100
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Date Information -->
                                <div class="col-md-12">
                                    <div class="row">
                                        <div class="col-12 mb-3 mb-md-0">
                                            <label>Booking Date*</label>
                                            <input type="datetime-local" class="form-control"
                                                formControlName="slot_date" required>
                                            <div *ngIf="submitted && f['slot_date'].errors"
                                                class="invalid-feedback d-block">
                                                <div *ngIf="f['slot_date'].errors['required']">Date is required</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <label>Slot Opens On*</label>
                                            <input type="date" class="form-control" formControlName="slot_opens_at"
                                                required>
                                            <div *ngIf="submitted && f['slot_opens_at'].errors"
                                                class="invalid-feedback d-block">
                                                <div *ngIf="f['slot_opens_at'].errors['required']">Slot opening time
                                                    is
                                                    required</div>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <label>Closes After (hours)*</label>
                                            <input type="number" class="form-control"
                                                formControlName="slot_closes_after" min="1" max="550" required>
                                            <div *ngIf="submitted && f['slot_closes_after'].errors"
                                                class="invalid-feedback d-block">
                                                <div *ngIf="f['slot_closes_after'].errors['required']">Closes after
                                                    time
                                                    is required</div>
                                                <div *ngIf="f['slot_closes_after'].errors['min']">Must be at least 1
                                                    hour</div>
                                                <div *ngIf="f['slot_closes_after'].errors['max']">Cannot exceed 168
                                                    hours (7 days)</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <label>Invites Sent On*</label>
                                            <input type="date" class="form-control" formControlName="invites_sent_at"
                                                required>
                                            <div *ngIf="submitted && f['invites_sent_at'].errors"
                                                class="invalid-feedback d-block">
                                                <div *ngIf="f['invites_sent_at'].errors['required']">Invites sent on
                                                    date is required</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Date Status -->

                                <div class="col-md-12" *ngIf="selectedDateId">
                                    <label>Status*</label>
                                    <select class="form-control" formControlName="status" required>
                                        <option value="Upcoming">Upcoming</option>
                                        <option value="Open">Open</option>
                                        <option value="Closed">Closed</option>
                                    </select>
                                    <div *ngIf="submitted && f['status'].errors" class="invalid-feedback d-block">
                                        <div *ngIf="f['status'].errors['required']">Status is required</div>
                                    </div>
                                </div>

                                <!-- Venue Information -->
                                <div class="col-md-12">
                                    <h4 class="mt-3 mb-3">Venue Details</h4>
                                </div>
                                <div class="col-md-12">
                                    <div>
                                        <label>Venue Name*</label>
                                        <input type="text" class="form-control" formControlName="venue_name"
                                            placeholder="Enter venue name" required>
                                        <div *ngIf="submitted && f['venue_name'].errors"
                                            class="invalid-feedback d-block">
                                            <div *ngIf="f['venue_name'].errors['required']">Venue name is required</div>
                                        </div>
                                    </div>
                                    <div>
                                        <label>Neighborhood*</label>
                                        <input type="text" class="form-control" formControlName="neighborhood"
                                            placeholder="Enter neighborhood" required>
                                        <div *ngIf="submitted && f['neighborhood'].errors"
                                            class="invalid-feedback d-block">
                                            <div *ngIf="f['neighborhood'].errors['required']">Neighborhood is required
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div>
                                        <label>Address*</label>
                                        <textarea class="form-control" formControlName="address" rows="3"
                                            placeholder="Enter address" required></textarea>
                                        <div *ngIf="submitted && f['address'].errors" class="invalid-feedback d-block">
                                            <div *ngIf="f['address'].errors['required']">Address is required</div>
                                        </div>
                                    </div>

                                    <div class="mb-3">
                                        <label>Search Location</label>
                                        <div class="input-group">
                                            <input type="text" class="form-control" id="locationSearch"
                                                placeholder="Search for a location (e.g., 'Eiffel Tower, Paris')">
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-secondary" type="button"
                                                    (click)="searchLocation()">
                                                    <i class="fa fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="map-container mb-3" style="height: 300px;">
                                        <div id="venueMap" style="height: 100%;"></div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6 mb-3">
                                            <label>Latitude*</label>
                                            <input type="number" class="form-control" formControlName="latitude"
                                                placeholder="Click on map to get latitude" step="any" required>
                                            <div *ngIf="submitted && f['latitude'].errors"
                                                class="invalid-feedback d-block">
                                                <div *ngIf="f['latitude'].errors['required']">Latitude is required</div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-3">
                                            <label>Longitude*</label>
                                            <input type="number" class="form-control" formControlName="longitude"
                                                placeholder="Click on map to get longitude" step="any" required>
                                            <div *ngIf="submitted && f['longitude'].errors"
                                                class="invalid-feedback d-block">
                                                <div *ngIf="f['longitude'].errors['required']">Longitude is required
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <label>Reservation Name*</label>
                                        <input type="text" class="form-control" formControlName="reservation_name"
                                            placeholder="Enter reservation name" required>
                                        <div *ngIf="submitted && f['reservation_name'].errors"
                                            class="invalid-feedback d-block">
                                            <div *ngIf="f['reservation_name'].errors['required']">Reservation name is
                                                required</div>
                                        </div>
                                    </div>

                                    <!-- Image Upload -->
                                    <div>
                                        <label>Restaurant Image*</label>
                                        <div class="custom-file-upload">
                                            <div *ngIf="existingImageUrl" class="existing-image mb-2">
                                                <img [src]="existingImageUrl" alt="Current restaurant image"
                                                    class="img-thumbnail" style="max-height: 200px;">
                                                <div class="mt-2">
                                                    <small class="text-muted">Current image</small>
                                                </div>
                                            </div>
                                            <input type="file" class="form-control" (change)="onFileSelected($event)"
                                                accept="image/*" [required]="!existingImageUrl && !selectedDateId">
                                            <div *ngIf="selectedImage" class="mt-2">
                                                <small class="text-muted">New image selected: {{ selectedImage.name
                                                    }}</small>
                                            </div>
                                        </div>
                                        <div *ngIf="submitted && !selectedImage && !existingImageUrl && !selectedDateId"
                                            class="invalid-feedback d-block">
                                            <div>Restaurant image is required</div>
                                        </div>
                                    </div>

                                    <!-- Is Published Toggle -->
                                    <div class="mt-4">
                                        <label class="toggle-switch">
                                            <input type="checkbox" class="form-control" formControlName="is_public">
                                            <span class="toggle-slider"></span>
                                            <span class="toggle-label">Publish Group Date</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="text-right mt-3">
                            <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">Cancel</button>
                            <span class="common_btn">
                                <button type="submit" class="create-date-btn" style="width: auto; margin:0px"
                                    [disabled]="isSubmitting">
                                    {{ isSubmitting ? (selectedDateId ? 'Updating...' : 'Creating...') : (selectedDateId
                                    ?
                                    'Update' : 'Create') }} Group Date
                                </button>
                            </span>

                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>